<template>
  <main-layout>
    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-78"></menubar>
    </div>
    <!--  左メニュー 終了 -->
    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">{{ $t('label.system.colorModel.setting') }}</label>
        <sp-smart-button @click="back" slot="cancel">
          {{ $t("button.common.data.cancel") }}
        </sp-smart-button>
      </head-title>
    </el-row>
    <!--  メインページ 開始  -->
    <div slot="body">
      <div class="hint-div">
        <div>
          <div class="hint">{{ $t("label.system.colorModel.hint1") }}</div>
          <div class="hint">{{ $t("label.system.colorModel.hint2") }}</div>
        </div>
        <narrow-down @click="updateDesignMode" class="save-btn">
          {{ $t("button.system.menuChange.applySettings") }}
        </narrow-down>
      </div>

      <hr class="hr-style">

      <el-radio-group v-model="designMode">
        <el-radio label="01">{{ $t("label.system.colorModel.DarkMode") }}</el-radio>
        <!-- <div class="initial-setting">
          {{ $t("label.system.colorModel.initial") }}
        </div> -->

        <div class="big-radio">
          <div class="pc-picture">
            <img src="@/assets/icon/PCDarkMode.png" alt="">
          </div>
          <div class="sp-picture">
            <img src="@/assets/icon/SPDarkMode.png" alt="">
          </div>
        </div>

        <hr class="hr-style">

        <el-radio label="02">{{ $t("label.system.colorModel.lightMode") }}</el-radio>
        <div class="big-radio">
          <div class="pc-picture">
            <img src="@/assets/icon/PCLightMode.png" alt="">
          </div>
          <div class="sp-picture">
            <img src="@/assets/icon/SPLightMode.png" alt="">
          </div>
        </div>
      </el-radio-group>
      <loading-dialog :dialogVisible="showLoading" />
    </div>
  </main-layout>
</template>

<script>
import SpSmartButton from "@/components/common/sp-smart-button-small"
import NewDesignLayout from "@/layout/NewDesignLayout"
import SystemManageApi from "@/api/SystemManageApi";
import Menubar from "@/components/leftmenu/DashBoard"
import headTitle from "@/components/common/head/head"
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import narrowDown from "@/components/common/generalButton/NarrowDown";
import LoadingDialog from "@/components/common/loading/LoadingDialog"

export default {
  name: "ColorModelSetting",
  components: {
    MainLayout: NewDesignLayout,
    SpSmartButton: SpSmartButton,
    Menubar: Menubar,
    headTitle: headTitle,
    narrowDown,
    LoadingDialog,
  },
  data() {
    return {
      designMode: '',
      ownerId: null,
      showLoading: false
    };
  },
  methods: {
    back() {
      this.$router.push({
        name: "system-owner-setting-edit",
        query: {
          orgId: this.ownerId,
          ownerDetail: JSON.stringify(this.ownerDetail)
        }
      })
    },
    init() {
      this.showLoading = true
      SystemManageApi.DesignModeGet(this.ownerId) // /system/owners/{owner_id}/design
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.designMode = data.body.designMode
        })
        .finally(() => {
        this.showLoading = false
      });
    },
    updateDesignMode() {
      this.showLoading = true
      SystemManageApi.DesignModeUpdate(this.ownerId, {designMode: this.designMode}) // /system/owners/{owner_id}/design
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.updateSuccess();
        })
        .finally(() => {
        this.showLoading = false
      });
    },
    updateSuccess() {
      this.$messageIotSuccess(this.$t("message.common.updateSuccess", {
        field: this.$t("label.router.colorModelSetting"),
      }));
    },

  },

  created() {
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "",
        title: "label.router.UserSetting",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);

  },
  mounted() {
    this.ownerId = this.$route.query.ownerId
    this.ownerDetail = JSON.parse(this.$route.query.ownerDetail)

    this.init()
  },
};

</script>

<style scoped lang="scss">
 ::v-deep .cancel-width{
  .my-button{
    height: 32px;
    width: 152px;
  }
}
.hint-div{
  margin-top: 200px;
  display: flex;
  justify-content: space-between;
  .hint {
    font-family: Hiragino Kaku Gothic Pro;
    font-size: 14px;
    font-weight: 300;
    line-height: 21px;
    text-align: left;
    clear: #525250;
  }
}
.hr-style {
  width: 1533px;
  margin-top: 24px;
  background: #D1D1CD;
  margin-bottom: 32px;
}
.big-radio{
  position: relative;
  left: 117px;
  top: -24px;
}
.radio-text{
  width: 83px;
  height: 21px;
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 14px;
  font-weight: 300;
  line-height: 21px;
  text-align: left;
  color: #525250;
}
.initial-setting{
  position: absolute;
  margin-top: 24px;
  width: 120px;
  height: 21px;
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 14px;
  font-weight: 300;
  line-height: 21px;
  text-align: left;
  color: #525250;
}
.pc-picture{
  display: inline-block;
  width: 376px;
  height: 236px;
  background: #D9D9D9;
  margin-left: 47px;
  margin-right: 24px;
}
.sp-picture{
  display: inline-block;
  width: 148px;
  height: 236px;
  left: 400px;
  background: #D9D9D9;
}
</style>
